//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IconBalanceRecords from "./components/IconBalanceRecords";
import IconBetRecords from "./components/IconBetRecords";
import IconMessages from "./components/IconMessages";
import IconSecurity from "./components/IconSecurity";
import IconPromotions from "./components/IconPromotions";
import IconInvite from "./components/IconInvite";
import IconPartners from "./components/IconPartners";
import IconContacts from "./components/IconContacts";

export default {
  data() {
    return {
      menus: [
        {
          icon: "IconBalanceRecords",
          langKey: "",
          name: "资金明细",
          path: "/My/merch-record",
        },
        {
          icon: "IconBetRecords",
          langKey: "",
          name: "投注记录",
          path: "/My/bet-record",
        },
        {
          icon: "IconMessages",
          langKey: "myMessages",
          name: "我的消息",
          path: "/My/StationLetter",
        },
        {
          icon: "IconSecurity",
          langKey: "",
          name: "安全中心",
          path: "/My/AccountManat",
        },
        {
          icon: "IconPromotions",
          langKey: "",
          name: "优惠活动",
          path: "/discounts",
        },
        {
          icon: "IconInvite",
          langKey: "",
          name: "邀请好友",
          path: "/My/InviteFriends",
        },
        {
          icon: "IconPartners",
          langKey: "myPartners",
          name: "商务合作",
          path: "/My/business",
        },
        {
          icon: "IconContacts",
          langKey: "",
          name: "联系方式",
          path: "/Service",
        },
        // { icon: 'IconContacts', langKey: '', name: '钱包管理', path: '/My/Wallet/AddWallet' },
      ],
    };
  },
  components: {
    IconBalanceRecords,
    IconBetRecords,
    IconMessages,
    IconSecurity,
    IconPromotions,
    IconInvite,
    IconPartners,
    IconContacts,
  },
  methods: {
    openMenu(menu) {
      let path =
        menu.langKey == "myPartners"
          ? this.$store.state.FrontConfigList.agent_url
          : menu.path;

      if (menu.target == "_blank") {
        if (!/^https?/i.test(path)) {
          path = `${location.href}${path}`;
        }
        window.open(path);
      } else {
        this.$router.push({ path });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/Base/components/GridMenus/index.vue